import React from 'react';
import styled from 'styled-components/macro';
import times from 'lodash.times';

import EntityItemLoader from 'components/utility/ContentLoader/EntityItemLoader/EntityItemLoader';

import { TableRow, EntityCell } from './TableRow.style';

const StyledEntityItemLoader = styled(EntityItemLoader)`
  padding: ${({ theme }): string => theme.spacing.small} 0 0;

  @media screen and (min-width: 50em) {
    padding: ${({ theme }): string => theme.spacing.small} 0;
  }
`;

interface IBrowseTableRowLoaderProps {
  rowCount?: number;
  columnCount?: number;
}

const BrowseTableRowLoader: React.FC<IBrowseTableRowLoaderProps> = (props) => {
  const { rowCount = 5, columnCount = 4 } = props;

  return (
    <>
      {times(
        rowCount,
        (idx: number): JSX.Element => (
          <TableRow key={`browse-entities-loader-${idx}`}>
            <EntityCell colSpan={columnCount}>
              <StyledEntityItemLoader />
            </EntityCell>
          </TableRow>
        )
      )}
    </>
  );
};

export default BrowseTableRowLoader;
